import Vue from 'vue'
import i18next from 'i18next'
import VueI18Next from '@panter/vue-i18next'
import XHR from 'i18next-xhr-backend'
import LngDetector from 'i18next-browser-languagedetector'

const isDebug = process.env.NODE_ENV === 'development'

let language = new URLSearchParams(window.location.search).get('language')

// 沒帶language參數的話直接不判斷語系、options的fallbackLng會自動帶入zh-cn
if (language) {
  switch (language.toLowerCase()) {
    case 'zh-tw':
      language = 'zh-tw'
      break

    case 'zh-cn':
    case 'cn':
      language = 'zh-cn'
      break

    case 'en-us':
    case 'en':
      language = 'en-us'
      break

    case 'vi-vn':
    case 'vi':
    case 'vn':
      language = 'vi-vn'
      break

    case 'th-th':
    case 'th':
      language = 'th-th'
      break

    default:
      language = 'en-us'
  }
}

Vue.use(VueI18Next)
const options = {
  lng: language || 'en-us',
  fallbackLng: 'en-us',
  lowerCaseLng: true,
  nsSeparator: false,
  keySeparator: false,
  backend: {
    loadPath: isDebug ? '/locales/{{lng}}/{{ns}}.json' : 'locales/{{lng}}/{{ns}}.json'
  },
  ns: ['general'],
  defaultNS: ['general'],
  whitelist: ['zh-cn', 'zh-tw', 'en-us', 'vi-vn', 'th-th'],
  load: 'currentOnly',
  interpolation: {
    escapeValue: false
  }
}

i18next.use(XHR).use(LngDetector).init(options)
const i18n = new VueI18Next(i18next)

export default i18n
